import React from 'react'
import MapaCoordenadas from './MapaCoordenadas'

export const Dinamico = ({campo,onChange,className}) => {

    switch (campo.field_type) {
        case 'text':
            return (<input onChange={onChange} className={className} type="text"></input>);
        break;

        case 'textarea':
            return (<textarea onChange={onChange} className={className}></textarea>);
        break;

        case 'mapa':
          
            return <MapaCoordenadas key="mapa_1" onLocationSelect={onChange} ></MapaCoordenadas>
        break;

        case 'select':
            if (campo.static_value_list!=null) {
                let opciones=campo.static_value_list.split(';');
                return (
                    <select
                        onChange={onChange} 
                        className={className} 
                    >
                        <option value={''}>-Seleccione una opción-</option>
                        {opciones.map((o,i)=>{
                            return <option 
                                    value={o}
                                    key={campo.id_definition_form+i} >
                                    {o}
                                    </option>     
                        })}
                        </select>
                );

            }
        break;
    
        case 'checkbox':
            if (campo.static_value_list!=null) {
                let opciones=campo.static_value_list.split(';');
                return (
                    <>
                    {opciones.map((o,i)=>{
                        return <><div className="form-check form-check-custom form-check-solid">
                           
                            <input 
                            name={campo.name_field}
                            onChange={onChange} 
                            className={'form-check-input me-3'} 
                            type="checkbox" 
                            key={campo.id_definition_form+i} 
                            id={campo.id_definition_form+i} 
                            value={o}/>
                            <label className="form-check-label" htmlFor={campo.id_definition_form+i}><div className="fw-bold">{o}</div></label>
                        </div>
                        <br/></>
                    })}
                    </>
                );

            }
        break;
    

        default:
        break;
    }
 
}
